import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  EditButton,
  DeleteButton,
  CreateButton,
  TopToolbar,
  FilterButton,
  TextInput,
  BooleanInput,
} from 'react-admin';
import { Card, CardContent } from '@mui/material';
import { PageWrapper } from '../../components/PageWrapper';

const useServiceProviderFilters = () => {
  return React.useMemo(
    () => [
      <TextInput key="q" label="Search" source="q" alwaysOn />,
      <BooleanInput key="active" label="Active Only" source="active" defaultValue={true} />,
    ],
    []
  );
};

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton />
  </TopToolbar>
);

export const ServiceProviderList = () => {
  const filters = useServiceProviderFilters();
  
  return (
    <PageWrapper title="Service Providers">
      <List
        filters={filters}
        actions={<ListActions />}
        sort={{ field: 'name', order: 'ASC' }}
      >
      <Datagrid rowClick="show">
        <TextField source="name" />
        <TextField source="address" />
        <TextField source="city" />
        <TextField source="provinceState" label="Province/State" />
        <TextField source="country" />
        <TextField source="phoneNumber" label="Phone" />
        <BooleanField source="active" />
        <EditButton />
        <DeleteButton />
      </Datagrid>
    </List>
    </PageWrapper>
  );
};